<template>
  <ContentWrapperControl
    no_bottom
    full_width
    class="min-h-screen bg-primary flex flex-col items-center overflow-y-auto z-poll papsi-poll py-3 px-4"
  >
    <div
      class="receipt-paper flex flex-col p-4 text-grey-darkest shadow-lg text-justify"
    >
      <div class="font-bold text-lg text-center mt-2">Proposed Amendments</div>
      <div class="bottom-spacing text-sm mt-6">Dear Fellow Member,</div>
      <div class="bottom-spacing text-sm">
        The Board of Directors is proposing for the approval of the attached
        amendments to PAFCPIC's Articles of Cooperation and By-laws.
      </div>
      <p
        class="text-primary font-bold bottom-spacing text-sm underline cursor-pointer"
        @click="show_pdf = true; this.$store.state.is_pdf_open = true;"
      >
        Click to read the Proposed Amendments to the PAFCPIC Articles of
        Cooperation and By-laws
      </p>
      <div class="font-bold bottom-spacing text-sm">
        Justification: To conform with the provisions of RA 9520 or the
        Philippine Cooperative Code of 2008, its Implementing Rules and
        Regulations and the Coop's Strategic Plan CY 2025-2029; and to correct
        typographical and grammatical error.
      </div>
      <div class="bottom-spacing text-sm">
        To cast your vote, you may check the appropriate box below.
      </div>
      <div class="bottom-spacing text-sm">Very truly yours,</div>
      <div class="w-full flex justify-start">
        <img :src="getSignature()" class="mt-2 w-1/3" />
      </div>
      <div class="font-bold text-sm">BGEN FRANCISCO M PAREDES (RET)</div>
      <div class="text-sm">Chairperson of the Board</div>
      <div class="border-b-2 w-full my-4"></div>
      <div class="text-sm">
        I hereby cast my vote on the proposed amendments to the PAFCPIC Articles
        of Cooperation and By-laws, as indicated below with a check mark:
      </div>
      <div class="papsi-grid mt-4 font-bold items-center text-sm mx-auto w-fit">
        <label
          class="flex flex-row justify-center items-center text-primary uppercase cursor-pointer mr-4"
        >
          <input
            type="checkbox"
            class="box mr-2"
            ref="approved"
            @click="select(true)"
            style="accent-color: #016b00"
          />
          <p>{{ lang("lbl_0000220") }}</p>
        </label>
        <label
          class="flex flex-row justify-center items-center text-error uppercase cursor-pointer"
        >
          <input
            type="checkbox"
            class="box mr-2"
            ref="disapproved"
            @click="select(false)"
            style="accent-color: #ef4444"
          />
          <p>{{ lang("lbl_0000221") }}</p>
        </label>
      </div>
      <div class="flex flex-row justify-center items-center mt-6">
        <ButtonControl
          :theme="'error'"
          @click="this.$router.push({ name: 'dashboard-page' })"
        >
          {{ lang("lbl_0000181") }}
        </ButtonControl>
        <ButtonControl
          class="ml-4"
          :disabled="approved == null"
          @click="show_confirm = true"
        >
          {{ lang("lbl_0000190") }}
        </ButtonControl>
      </div>
    </div>
    <ModalControl
      @closed="show_pdf = false; this.$store.state.is_pdf_open = false;"
      :show="show_pdf"
      :dismiss="true"
      :title="'Proposed Amendments'"
      :nopadd="true"
    >
      <div
        v-for="(_, i) in page_count"
        :key="i"
        class="mb-2 flex flex-col items-center"
      >
        <div class="relative inline-block">
          <div
            v-if="image_loaded[i]"
            class="absolute mt-1 ml-10 bg-black text-white text-xs px-3 py-2 rounded-full z-10"
            style="background-color: rgba(0, 0, 0, 0.6)"
          >
            {{ i + 1 }} of {{ page_count }}
          </div>
          <vue-image-zoomer
            :regular="getImage(i + 1)"
            @regular-loaded="onImageLoad(i)"
          />
          <img
            v-if="!image_loaded[i]"
            class="w-icon h-icon my-5 mt-2"
            src="@/assets/icons/papsi_spinner.svg"
            alt="Loading..."
          />
        </div>
        <div
          v-if="i < page_count - 1"
          class="w-full mb-2 border-b"
          style="height: 0px"
        ></div>
      </div>
    </ModalControl>
    <ModalControl
      @closed="show_success = false"
      :dismiss="false"
      :show="show_success"
      :title="lang('lbl_0000225')"
    >
      <div class="flex flex-col">
        <span class="mt-2">{{ lang("lbl_0000217") }}</span>
        <ButtonControl
          class="mt-4"
          @click="
            show_rating = true;
            show_success = false;
          "
        >
          {{ lang("lbl_0000015") }}
        </ButtonControl>
      </div>
    </ModalControl>
    <ModalControl
      @closed="show_rating = false"
      :dismiss="true"
      :show="show_rating"
      :title="lang('lbl_0000226')"
    >
      <div class="flex flex-col">
        <span class="mt-2">{{ lang("lbl_0000218") }}</span>
        <div class="flex flex-col items-center mt-4">
          <SpecialRatingControl v-bind:submit="submit" :type="1" />
        </div>
        <div class="flex flex-row mt-4">
          <ButtonControl
            :theme="'error'"
            @click="
              show_rating = false;
              this.$router.push({ name: 'dashboard-page' });
            "
            class="mr-4"
          >
            {{ lang("lbl_0000199") }}
          </ButtonControl>
          <ButtonControl @click="submitRating()">
            {{ lang("lbl_0000190") }}
          </ButtonControl>
        </div>
      </div>
    </ModalControl>
    <ModalControl
      @closed="show_confirm = false"
      :dismiss="true"
      :show="show_confirm"
      :title="lang('lbl_0000224')"
    >
      <div class="flex flex-col">
        <span class="mt-2">
          {{ lang("lbl_0000222") }}
        </span>
        <span class="font-semibold mt-4 mb-2">
          {{ lang("lbl_0000223") }}
        </span>
      </div>
      <div class="flex flex-row mt-4">
        <ButtonControl
          :theme="'error'"
          @click="show_confirm = false"
          class="mr-4"
        >
          {{ lang("lbl_0000181") }}
        </ButtonControl>
        <ButtonControl :theme="'success'" @click="submitVote()">
          {{ lang("lbl_0000190") }}
        </ButtonControl>
      </div>
    </ModalControl>
  </ContentWrapperControl>
</template>

<script>
import mixin from "./../../mixin.js";
import GA from "../../services/GA.js";
import ModalControl from "./../../components/controls/ModalControl.vue";
import ButtonControl from "./../../components/controls/ButtonControl.vue";
import ContentWrapperControl from "@/components/controls/ContentWrapperControl.vue";
import SpecialRatingControl from "@/components/controls/SpecialRatingControl.vue";
import "vue-image-zoomer/dist/style.css";

export default {
  mixins: [mixin],
  emits: ["checkauth", "hidenavbar", "nofooter", "showloader", "hideloader"],
  components: {
    ModalControl,
    ButtonControl,
    ContentWrapperControl,
    SpecialRatingControl,
  },
  data() {
    return {
      state: null,
      submit: false,
      show_pdf: false,
      show_confirm: false,
      show_success: false,
      show_rating: false,
      display: false,
      page_count: 35,
      image_loaded: [],
      code: null,
      approved: null,
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("hidenavbar");
    this.$emit("nofooter", true);

    if(this.$store.state.login){
      this.fetchSGA();
      this.image_loaded = Array(this.page_count).fill(false);
    }
  },
  methods: {
    fetchSGA() {
      this.$emit("showloader");
      GA.special()
        .then((response) => {
          let data = response.data.data,
            state = this.$store.state.sga;
          state.code = data.code;
          this.code = data.code;
          state.date = data.date;
          state.title = data.title;
          state.user.uuid = data.user.uuid;
          state.user.can_participate = data.user.can_participate;
          state.user.has_participated = data.user.has_participated;
          state.schedules.has_started = data.schedules.has_started;
          state.schedules.has_ended = data.schedules.has_ended;
          state.schedules.start_date = data.schedules.start_date;
          state.schedules.end_date = data.schedules.end_date;
          this.$emit("hideloader");

          if (this.$store.state.sga.user.has_participated) {
            // this.$emit("error", "Member has already participated.");
            this.$router.push({ name: "dashboard-page" });
            return;
          }
        })
        .catch((error) => {
          this.$emit("hideloader");
          this.$emit("error", error);
        });
    },
    select(value) {
      if (this.approved === value) {
        this.approved = null; // uncheck both
      } else {
        this.approved = value; // set new value
      }

      this.$refs.approved.checked = this.approved === true;
      this.$refs.disapproved.checked = this.approved === false;
    },
    getLogo() {
      return (
        "background-image: url('" +
        this.getMediaPath("/logo/pafcpic.png") +
        "')"
      );
    },
    getImage(index) {
      const padded_index = String(index).padStart(4, "0");
      const file_name = "ACBL_2025_page-" + padded_index + ".jpg";
      const path = "referendum/ACBL_2025";
      return this.getAsset(path, file_name);
    },
    getSignature() {
      const file_name = "chairman_signature" + ".jpg";
      const path = "referendum/";
      return this.getAsset(path, file_name);
    },
    submitVote() {
      this.show_confirm = false;
      this.$emit("showloader");
      GA.submitPoll(
        this.code, // "GA00000002",
        this.$store.state.hash,
        this.$store.state.key,
        this.approved ? 1 : 0
      )
        .then(() => {
          this.$emit("hideloader");
          this.show_success = true;
        })
        .catch((error) => {
          this.$emit("error", error);
          this.$router.push({ name: "dashboard-page" });
        });
    },
    submitRating() {
      this.submit = true;
      this.$router.push({ name: "dashboard-page" });
    },
    onImageLoad(index) {
      this.image_loaded[index] = true;
    },
  },
};
</script>

<style>
.bottom-spacing {
  margin-bottom: 1rem;
}

.receipt-paper {
  background: white;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.papsi-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 1rem;
}

.box {
  width: 1rem !important;
  height: 1rem !important;
  margin-right: 0.5rem !important;
}
</style>
